import { request } from './request'
// 任务信息
export interface GetResultInfo {
  resultId?: string
  taskId?: string
  userId?: string
}
export const getResultInfo = (data: GetResultInfo) =>
  request('/portal/verify/emailGateway/resultInfo', {
    params: {
      ...data,
    },
  })
// 删除任务结果
export interface DeleteResult {
  result_id: string
  task_id: string
}
export const deleteResult = (data: DeleteResult) =>
  request('/portal/verify/emailGateway/deleteResult', {
    method: 'delete',
    data,
  })

// 进度信息
export interface ResultProgressList {
  result_id: string
  task_id: string
}
export const resultProgressList = (data: ResultProgressList) =>
  request('/portal/verify/emailGateway/resultProgressList', {
    params: {
      ...data,
    },
  })
// 进度信息日志
export interface ResultProgressDetail {
  id: string
}
export const resultProgressDetail = (data: ResultProgressDetail) =>
  request('/portal/verify/emailGateway/resultProgressDetail', {
    params: {
      ...data,
    },
  })
// 模板名称列表
export interface ResultTemplateNameList {
  result_id: string
  task_id: string
}
export const resultTemplateNameList = (data: ResultTemplateNameList) =>
  request('/portal/verify/emailGateway/resultTemplateNameList', {
    params: {
      ...data,
    },
  })
// 附件/URL列表
export interface ResultResourceList {
  result_id: string | undefined
  task_id: string | null
  page: number
  limit: number
  keyword?: string
  intercept_status?: string
  risk_level?: string
  attack_type?: string
  template_id?: string
  resource_type?: string
  attachment_type?: string
  att_ck?: string
  tag_ids?: string[]
}
export const resultResourceList = (data: ResultResourceList) =>
  request('/portal/verify/emailGateway/resultResourceList', {
    method: 'post',
    data,
  })
// 任务摘要
export interface ResultDetail {
  result_id: string
  task_id: string
}
export const resultDetail = (data: ResultDetail) =>
  request('/portal/verify/emailGateway/resultDetail', {
    params: {
      ...data,
    },
  })
// 任务详情
export interface ResultResourceDetail {
  id: string
  resource_type: number
}
export const resultResourceDetail = (data: ResultResourceDetail) =>
  request('/portal/verify/emailGateway/resultResourceDetail', {
    params: {
      ...data,
    },
  })
// 邮件详情
export interface ResultResourceEmailDetail {
  id: string
}
export const resultResourceEmailDetail = (data: ResultResourceEmailDetail) =>
  request('/portal/verify/emailGateway/resultResourceEmailDetail', {
    params: {
      ...data,
    },
  })

//
export interface DetailAttCkList {
  result_id: string
  task_id: string
}
//获取url/附件列表的attck
export const getDetailAttCkList = (data: DetailAttCkList) =>
  request('/portal/verify/emailGateway/detailAttCkList', {
    params: {
      ...data,
    },
  })

export interface ResultDefenseRankings {
  result_id: string
}
//攻击防护排名
export const resultDefenseRankings = (data: ResultDefenseRankings) =>
  request('/portal/verify/emailGateway/resultDefenseRankings', {
    params: {
      ...data,
    },
  })

export const getFailPluginLog = data =>
  request('/portal/verify/emailGateway/failedResource', {
    params: {
      ...data,
    },
  })

// 获取攻击类型列表
export const getAttackTypeList = () => request('/portal/verify/emailGateway/attack_types')

// 树结构标签选项
export const getTagTreeOptions = data =>
  request('/portal/verify/emailGateway/resultList/tag_snapshot', { params: data })

// 更新资源拦截状态
export const updateInterceptStatus = data =>
  request(`/portal/verify/emailGateway/result/resourceIntercept/${data.id}`, {
    method: 'PUT',
    data: {
      taskResultResourceList: data.taskResultResourceList,
    },
  })

// 2.0.2
// 获取离线日志导入信息
export const getOfflineLogImportInfo = id =>
  request(`/portal/verify/email_gateway/results/${id}/get_log_device_import_records`)

// 删除日志设备导入记录
export const deleteOfflineLogImportRecord = data =>
  request(
    `/portal/verify/email_gateway/results/${data.resultId}/log_device_import_record/${data.id}`,
    {
      method: 'delete',
      timeout: 60000,
    },
  )

// 攻击防护排名
export const getAttackDefenseRanking = data =>
  request(`/portal/verify/emailGateway/result/${data.resultId}/attack_defense_ranking`)

// 附件类型排名
export const getAttachmentTypeRanking = data =>
  request(`/portal/verify/email_gateway/result/${data.resultId}/attachment_ranking`)

// 危险等级分布
export const getRiskLevelDistribution = data =>
  request(`/portal/verify/email_gateway/result/${data.resultId}/hazard_levels_ranking`)

// 用例等级分布
export const getResourceLevelsRanking = data =>
  request(`/portal/verify/email_gateway/result/${data.resultId}/resource_levels_ranking`)

// 模板防护失效率排名
export const getTemplateLoseEfficacyRanking = data =>
  request(`/portal/verify/email_gateway/result/${data.resultId}/template_lose_efficacy_ranking`)

// 验证结果分布
export const getVerifyDistribution = data =>
  request(`/portal/verify/email_gateway/result/${data.resultId}/verify_distribution`)

// 设备防护列表
export const getDeviceProtectionList = data =>
  request(`/portal/verify/email_gateway/task_results/${data.resultId}/device_defences`)

// 任务评分
export const getTaskScore = data =>
  request(`/portal/verify/email_gateway/result/${data.resultId}/socre`)

// 执行信息
export const getExecuteInfo = data =>
  request(`/portal/verify/emailGateway/${data.resultId}/case/progress`)

// 子任务过滤数据
export const getSubTaskFilterData = data =>
  request(`/portal/verify/emailGateway/${data.resultId}/filter`)

// 离线日志导入
export const uploadMailLog = data =>
  request(`/portal/verify/email_gateway/results/${data.resultId}/import_log`, {
    method: 'post',
    data,
  })

// 获取攻击组织
export const getAPTList = data =>
  request('/portal/verify/emailGateway/resultApts', { params: data })

// 获取attck级联数据
export const getAttckCascaderData = data =>
  request('/portal/verify/emailGateway/detailAttCkList', { params: data })
